import { IMessage } from '@mnz-core/models/message';
import * as authActions from '@mnz-modules/login/store/actions/auth.actions';
import { createReducer, on } from '@ngrx/store';

export const initialState: IAuthState = {
  bearerToken: null,
  loading: false,
  messageFail: null,
  userInput: null,
  jwsToken: null,
  prefilledEmail: null
};

export interface IAuthState {
  readonly bearerToken: string;
  readonly loading: boolean;
  readonly messageFail: IMessage;
  readonly userInput: string;
  readonly jwsToken: string;
  readonly prefilledEmail: string;
}

export const reducer = createReducer(
  initialState,
  on(authActions.resetState, (state) => ({ ...state, loading: false, messageFail: null, toNewPortal: false })),
  on(authActions.authenticate, (state) => ({ ...state, loading: true, messageFail: null })),
  on(authActions.authenticateFail, (state, { message: messageFail = null }) => {
    return { ...state, bearerToken: null, messageFail, loading: false, jwsToken: null };
  }),
  on(authActions.resetFailMessage, (state) => {
    return { ...state, messageFail: null}
  }),
  on(authActions.authenticateSuccess, (state, { login }) => ({
    ...state,
    bearerToken: login.bearerToken,
    jwsToken: login.jwsToken,
  })),
  on(authActions.setUserInput, (state, { userInput }) => {
    return { ...state, userInput };
  }),
  on(authActions.setLoading, (state, { loading }) => ({ ...state, loading })),
  on(authActions.logoutSuccess, (state) => {
    return { ...state, bearerToken: null, loading: false, jwsToken: null };
  }),
  on(authActions.refreshToken, (state) => ({ ...state, loading: true, messageFail: null })),
  on(authActions.refreshTokenFail, (state, { message: messageFail = null }) => {
    return { ...state, bearerToken: null, messageFail, loading: false, jwsToken: null };
  }),
  on(authActions.refreshTokenSuccess, (state, { login }) => ({
    ...state,
    bearerToken: login.bearerToken,
    jwsToken: login.jwsToken,
  })),
  on(authActions.doSamlLogin, (state) => ({ ...state, loading: true, messageFail: null })),
  on(authActions.samlLoginSuccess, (state) => ({ ...state })),
);
